<template>
    <div v-if="is_show">
        <div>
            <MerchantsDay20210312 />
        </div>
        <router-link v-if='is_boss' to="ShopSwitch">
            <div class="title">
                <div class="title_left">
                    <div class="title_left_name">店铺消息接收设置</div>
                    <div class="no_disturb_tip">
                        可设置是否接收店铺未回复消息提醒
                    </div>
                </div>
                <span class="title_icon"><i class="iconfont icon-xiangyou"></i></span>
            </div>
        </router-link>
        <div class="switch_box" v-if="GetRemindChannelSet && is_boss">
            <div class="switch_title">消息接收渠道</div>
            <div class="switch_item">
                <div class="item_name">微信消息</div>
                <div class="item_switch_box">
                    <van-switch class="vant_switch" :value="GetRemindChannelSet['close_wx_remind']==1?false:true" @input="switch_touch('close_wx_remind')" active-color="#45DB5E" inactive-color="rgb(199,199,199)" />
                </div>
            </div>
            <div class="switch_item">
                <div class="item_name">
                    <span class="item_name_text">
                        短信消息
                        <div v-if="UserInfo.is_free!=0" class="item_name_tips">付费开通</div>
                    </span>
                    <div v-if="UserInfo.is_free!=0" class="item_name_give">升级每月赠送200条短信</div>
                </div>
                <div class="item_switch_box">
                    <van-switch class="vant_switch" :value="GetRemindChannelSet['close_sm_remind']==1?false:true" @input="switch_touch('close_sm_remind')" active-color="#45DB5E" inactive-color="rgb(199,199,199)" />
                </div>
            </div>
            <div class="switch_item">
                <div class="item_name">
                    <span class="item_name_text">
                        语音电话
                        <div v-if="UserInfo.is_free!=0" class="item_name_tips">付费开通</div>
                    </span>
                    <div v-if="UserInfo.is_free!=0" class="item_name_give">升级每月赠送50分钟电话</div>
                </div>
                <div class="item_switch_box">
                    <van-switch class="vant_switch" :value="GetRemindChannelSet['close_tele_remind']==1?false:true" @input="switch_touch('close_tele_remind')" active-color="#45DB5E" inactive-color="rgb(199,199,199)" />
                </div>
            </div>
        </div>
        <!-- <div class="switch_box" v-if="GetRemindChannelSet && is_boss && GetRemindChannelSet['show_close_trade_success']==1">
            <div class="switch_title">消息提醒类型</div>
            <div class="switch_item">
                <div class="item_name">交易成功提醒</div>
                <div class="item_switch_box">
                    <van-switch class="vant_switch" :value="GetRemindChannelSet['close_trade_success']==1?false:true" @input="switch_touch('close_trade_success')" active-color="#45DB5E" inactive-color="rgb(199,199,199)" />
                </div>
            </div>
        </div> -->
        <div v-if="GetRemindChannelSet && is_boss" @click="set_time" class="no_disturb_box">
            <div class="no_disturb">
                <span class="no_disturb_text">提醒时间设置</span>
                <span class="no_disturb_time">{{GetRemindChannelSet.remind_time_set}}分钟<i class="iconfont icon-xiangyou settime_icon"></i></span>
            </div>
            <div class="no_disturb_tip">
                {{GetRemindChannelSet.remind_time_set}}分钟未回复的买家旺旺消息进行提醒
            </div>
        </div>
        <div class="no_disturb_box" v-if="stroeArr.length>0">
            <div class="no_disturb">
                <span class="no_disturb_text">消息免打扰设置</span>
            </div>
            <div class="no_disturb_tip">
                此时间段内产生的未回复消息不会推送给您
            </div>
            <p class="noDisturbTip">*店铺时间选择开始00:00-结束00:00，默认为全天24小时为您提醒</p>
            <div class="no_disturb_handle">
                <div class="chooseStroe" @click="chooseStroeBtn">
                    <p style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{stroeArr[chooseStroeActive].visitor_nick}}</p>
                    <i v-if="stroeArr.length>1" class='iconfont icon-xiangyou'></i>
                </div>
                <div class="chooseStroe" @click="chooseTimeBtn">
                    <p>开始  {{stroeArr[chooseStroeActive].mute_start_time}}<span>-</span>结束  {{stroeArr[chooseStroeActive].mute_end_time}}</p>
                    <i v-if="stroeArr[chooseStroeActive].is_boss" class='iconfont icon-xiangyou'></i>
                </div>
            </div>
        </div>
        <!-- 子账号分流设置 -->
        <router-link v-if='is_boss' to="ChildInformation">
            <div @click="savePvUv" class="no_disturb_box" style="margin-bottom: 1px;">
                <div class="no_disturb">
                    <span class="no_disturb_text">子账号分流设置</span>
                    <span class="no_disturb_time"><i class="iconfont icon-xiangyou settime_icon"></i></span>
                </div>
                <div class="no_disturb_tip">
                    可指定消息类型分配给指定接收人
                </div>
            </div>
        </router-link>
        <!-- 消息过滤设置 -->
        <router-link to="FilterSet">
            <div v-if="GetRemindChannelSet && is_boss" class="no_disturb_box">
                <div class="no_disturb">
                    <span class="no_disturb_text">消息过滤设置</span>
                    <span class="no_disturb_time"><i class="iconfont icon-xiangyou settime_icon"></i></span>
                </div>
                <div class="no_disturb_tip">
                    勾选过滤后旺旺上有{{timeNum}}分钟未回复的此类型消息，将不再向您推送提醒
                </div>
            </div>
        </router-link>
        <!-- 店铺账号绑定 -->
        <router-link to="BuildAccount">
            
            <div class="title">
                <div class="title_left">
                    <div class="title_left_name">店铺账号绑定</div>
                    <div class="no_disturb_tip" v-if="is_boss">
                        可更换店铺绑定的负责人
                    </div>
                </div>
                <span class="title_icon"><i class="iconfont icon-xiangyou"></i></span>
            </div>
        </router-link>
        
        <div>
            <Popup v-model="confir_box" >
                <!-- 点击微信的弹窗 -->
                <template v-if="touch_switch=='close_wx_remind'"> 
                    <div class="remind_box">
                        <div @click="confir_false" class="close_popup">
                            <i class="iconfont icon-close"></i>
                        </div>
                        <div class="confir_icon_box">
                            <img :src="OSSBaseUrl+'confir_small_bell.png'" class="confir_icon" >
                        </div>
                        <div class="confir_text">
                            微信消息为默认接收渠道，不可关闭。如拒接所有消息，请在<router-link class="link" to="ShopSwitch">店铺消息接收设置</router-link>中修改。
                        </div>
                    </div>
                </template>
                <!-- 点击语音电话的弹窗 -->
                <template v-if="touch_switch=='close_tele_remind'">
                    <div class="confir_box">
                        <div class="confir_icon_box">
                            <img :src="OSSBaseUrl+'confir_small_bell.png'" class="confir_icon" >
                        </div>
                        <div class="confir_title">
                            开启语音电话,同一个客户第二次未读消息将以语音电话形式为您提醒,确定开启么?
                        </div>
                        <div class="confir_btn_box">
                            <div @click="confir_false" class="confir_btn btn_false">
                                我再想想
                            </div>
                            <div @click="confir_true" class="confir_btn btn_true">
                                确定
                            </div>
                        </div>
                    </div>
                </template>
            </Popup>
        </div>
        <Popup v-model="set_time_popup" round position="bottom">
            <Picker @confirm="confirm_set_time" @cancel="cancel_set_time" 
                show-toolbar title="提醒时间" item-height="12vw"  visible-item-count="5"
                :defaultIndex="_.findIndex(set_time_list,(f)=>{return f.remind_time_set==GetRemindChannelSet.remind_time_set})"
                :columns="set_time_list" confirm-button-text="确定" />
        </Popup>
        <ManualHelp />
        <CouponsPopup />
        <Popup v-model="free_shop_popup">
            <div class="free_shop_popup_box">
                <i @click="free_shop_popup_close" class="iconfont icon-close free_shop_popup_close"></i>
                <div class="free_shop_popup_title">
                    <span v-for="(item,index) in UserInfo.visitor_nick" :key="index">
                        {{index!=0?'、':''}}{{item}}
                    </span>
                </div>
                <div class="free_shop_popup_text">
                    共有{{UserInfo.visitor_nick.length}}个店正在使用免费版本<br />
                    <span style="color: #ff2300">暂不支持使用语音和短信渠道提醒</span><br />
                    如需使用请立即升级
                </div>
                <div @click="free_shop_popup_button" class="free_shop_popup_button">立即升级</div>
            </div>
        </Popup>
        <Popup :close-on-click-overlay='false' v-model="choose_time_popup" round position="bottom">
            <div class="chooseTimePopup">
                <div class='chooseTimeTitle'>
                    <div @click="changeTimeBtn(0)" :class="chooseTimeActive==0 ?'chooseTimeActive' :''">
                        {{chooseTimeValue[0]}}
                    </div>
                    <p>至</p>
                    <div @click="changeTimeBtn(1)" :class="chooseTimeActive==1 ?'chooseTimeActive' :''">
                        {{chooseTimeValue[1]}}
                    </div>
                </div>
                <p class="choooseTipClass">请选择-{{chooseText}}时间</p>
                
                <DatetimePicker
                    v-model="currentTime"
                    type="time"
                    title="选择时间"
                    @change="timeChange"
                    visible-item-count='3'
                />
                <div class="chooseFooter">
                    <div @click="noneBtn">
                        取消
                    </div>
                    <div class="determineBtn" @click="determineBtn">
                        确定
                    </div>
                </div>
                <div class="maskClass">
                    
                </div>
            </div>
            
        </Popup>
        <div class='chooseStroeDiv'>
            <Popup :close-on-click-overlay='false' round position="bottom" v-model="choose_stroe_popup">
                <div class="chooseStroePopup">
                    <p class="chooseStroeTitle">店铺选择</p>
                    <div class="stroeBox">
                        <div :class="stroeActive==index ?'stroeItem active' :'stroeItem'" v-for="(item, index) in stroeArr" :key='index' @click="changeStroe(index)">
                            <p>{{item.visitor_nick}}</p>
                            <div>
                                <i v-if="stroeActive==index" class="iconfont icon-duihao"></i>
                            </div>
                        </div>
                    </div>
                    <div class='chooseStroeFooter'>
                        <div @click="noneStroe">
                            取消
                        </div>
                        <div class='determineBtn' @click="stroeDetermineBtn">
                            确定
                        </div>
                    </div>
                </div>
            </Popup>
        </div>
        
    </div>
</template>
<script>
import { Switch , Toast , Picker , Popup , DatetimePicker } from 'vant';
import { mapState } from 'vuex';
import MerchantsDay20210312 from '@/components/MerchantsDay20210312';
import ManualHelp from '@/components/ManualHelp';
import CouponsPopup from '@/components/CouponsPopup';
import { URL6 } from '@/utils/Redirect';
export default {
    name: 'MessageSwitch',
    data(){
        return{
            choose_time_popup: false,
            choose_stroe_popup: false,
            is_show: false,
            OSSBaseUrl: this.$OSSBaseUrl,
            is_boss: false,
            confir_box: false,
            touch_switch: null,
            free_shop_popup: false,
            set_time_popup: false,
            set_time_list:[
                {text:'1分钟',remind_time_set:'1'},
                {text:'2分钟',remind_time_set:'2'},
                {text:'3分钟',remind_time_set:'3'},
                {text:'4分钟',remind_time_set:'4'},
                {text:'5分钟',remind_time_set:'5'},
            ],
            timeNum: 1,
            chooseTimeValue: ['', ''],
            chooseTimeActive: 0,
            hourArr: ['-2'],
            minuteArr: ['-2'],
            hourTextHeightValue: 0,
            minuteTextHeghtValue: 0,
            currentTime: '00:00',
            stroeActive: 0,
            chooseStroeActive: 0,
            minuteTimer: '',
            hourTimer: '',
            hourMarginTop: {
                marginTop: '0vw'
            },
            stroeArr: [],
            chooseText: '开始',
        }
    },
    components:{
        Popup,
        Picker,
        vanSwitch:Switch,
        MerchantsDay20210312,
        ManualHelp,
        CouponsPopup,
        DatetimePicker
    },
    mounted(){
        this.getData()
    },
    
    computed:{
        ...mapState({
            GetRemindChannelSet: (state)=>{
                return state.MessageSwitch.GetRemindChannelSet
            },
            GetAccountBindList: (state)=>{
                return state.BuildAccount.GetAccountBindList
            },
            UserInfo: (state) => {
                return state.Public.UserInfo;
            },
        })
    },
    methods:{
        free_shop_popup_close(){
            this.free_shop_popup = false
        },
        free_shop_popup_button(){
            window.location.href = URL6
        },
        getData() {
            this.$store.dispatch('BuildAccount/GetAccountBindList',{}).then(res=>{
                if(res.code !== 1000 && res.code !== 4010 && res.code !== 4024 && res.code !== 5013){
                    Toast(res.message)
                }
                // if(this.getAccountBindList.list && this.getAccountBindList.list.length>0) {
                //     this.contentShow = true
                //     this.lostShow = false
                // }else {
                //     this.contentShow = false
                //     this.lostShow = true
                // }
            })
            this.$store.dispatch('MessageSwitch/GetRemindChannelSet',{}).then(res=>{
                this.timeNum = res.data.remind_time_set
                this.is_show = true
                if(res.data.has_boss_role == 0){
                    this.is_boss = false
                }
                if(res.data.has_boss_role == 1){
                    this.is_boss = true
                }
                this.stroeArr = res.data.muteInfo

                
                this.stroeActive = 0
                this.chooseStroeActive = 0
            })
        },
        confirm_set_time(value,index){
            this.$store.dispatch('MessageSwitch/SetRemindChannel',{ remind_time_set: value.remind_time_set}).then(res=>{
                if(res.code==1000){
                    this.$store.commit('MessageSwitch/CHANGE_DATA',{key:'remind_time_set',data: value.remind_time_set})
                    this.getData()
                }else{
                    Toast(res.message)
                }
            })
            this.set_time_popup = false
            
        },
        cancel_set_time(){
            this.set_time_popup = false
        },
        set_time(){
            this.set_time_popup = true
        },
        set_switch(){
            let index = this.touch_switch
            let data = JSON.parse(JSON.stringify(this.GetRemindChannelSet))
            data[index] = data[index]==0?1:0;
            this.$store.dispatch('MessageSwitch/SetRemindChannel',{
                close_wx_remind: data.close_wx_remind,
                close_sm_remind: data.close_sm_remind,
                close_tele_remind: data.close_tele_remind,
                remind_time_set: data.remind_time_set,
                close_trade_success: data.close_trade_success,
            }).then(res=>{
                if(res.code == 1000){
                    this.$store.commit('MessageSwitch/SET_DATA',{key:'GetRemindChannelSet',data:data})
                    switch (index) {
                        case 'close_sm_remind':
                            Toast(`已${data[index]==0?'开启':'关闭'}短信提醒功能`)
                        break;
                        case 'close_tele_remind':
                            Toast(`已${data[index]==0?'开启':'关闭'}语音电话提醒功能`)
                        break;
                        case 'close_trade_success':
                            Toast(`已${data[index]==0?'开启':'关闭'}交易成功提醒功能`)
                        break;
                    }
                }else{
                    Toast(res.message)
                    if(res.code==4026){ // 未绑定手机号引导去绑定手机号
                        sessionStorage.setItem('BootBuildPhone',index)
                        setTimeout(()=>{
                            let only_one_boss = true
                            let only_one_id = ''
                            this.GetAccountBindList.list.map((m,index)=>{
                                if(m.is_boss==1){
                                    if(!only_one_id){
                                        only_one_id = m.id
                                    }else{
                                        only_one_boss = false
                                    }
                                }
                            })
                            if(only_one_boss){
                                sessionStorage.setItem('Phone_Account_ID',only_one_id)
                                this.$router.push({ path:'BuildPhone', query:{page_from:'change_mobile'}})
                            }else{
                                this.$router.push('BuildAccount')
                            }
                        },2000)
                    }
                }
            })
        },
        switch_touch(index){
            this.touch_switch = index
            if(!this.is_boss){
                Toast('您暂无权限设置，请联系老板处理')
                return false;
            }
            if(index=='close_wx_remind'){
                this.confir_box = true
                return false;
            }
            if( this.UserInfo.is_free!=0 && this.GetRemindChannelSet[index]==1 ){
                Toast("此消息渠道付费版才可使用，请先升级")
                return false;
            }
            if( this.UserInfo.visitor_nick.length!=0 && this.GetRemindChannelSet[index]==1 && ((index=='close_tele_remind')||(index=='close_sm_remind'))){
                this.free_shop_popup=true
            }
            let timer = setInterval(()=>{ // 有提醒升级的弹窗时不执行后续操作
                if(!this.free_shop_popup){
                    clearInterval(timer)
                    if( (index=='close_tele_remind') && (this.GetRemindChannelSet[index]==1) ){ // 语音消息给提醒
                        this.confir_box = true
                        return false;
                    }
                    // 符合条件才响应点击
                    this.set_switch()
                }
            },100)
        },
        confir_true(){
            this.set_switch()
            this.confir_box = false
        },
        confir_false(){
            this.confir_box = false
        },
        savePvUv() {
            let data = {
                page_from:'main_page',
                page_name:'MessageSwitch',
                btn_name: 'ChildInformationBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
                
            };
            this.$store.dispatch('Public/inH5Record', data)
        },
        chooseTimeBtn() {
            if(this.stroeArr[this.chooseStroeActive].is_boss) {
                this.choose_time_popup = true
                this.chooseTimeValue[0] = this.stroeArr[this.chooseStroeActive].mute_start_time
                this.chooseTimeValue[1] = this.stroeArr[this.chooseStroeActive].mute_end_time
                this.currentTime = this.chooseTimeValue[0]
                this.chooseText = '开始'
            }else {
                Toast('您没有权限更改，请联系店主')
            }
            
            let data = {
                page_from:'main_page',
                page_name:'MessageSwitch',
                btn_name: 'chooseTimeBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
                
            };
            this.$store.dispatch('Public/inH5Record', data)
        },
        changeTimeBtn(index) {
            this.chooseTimeActive = index
            if(index == 0) {
                this.currentTime = this.chooseTimeValue[0]
            }
            if(index == 1) {
                this.currentTime = this.chooseTimeValue[1]
            }
            this.chooseText = index==0 ?'开始' :'结束'
        },
        
        
        timeChange() {
            if(this.chooseTimeActive == 0) {
                this.chooseTimeValue[0] = this.currentTime
            }
            if(this.chooseTimeActive == 1) {
                this.chooseTimeValue[1] = this.currentTime
            }
            this.$forceUpdate()
        },
        noneBtn() {
            this.colsePopup()
        },
        determineBtn() {
            if(this.chooseTimeValue[0] == '') {
                Toast('请选择开始时间')
                return false
            }
            if(this.chooseTimeValue[1] == '') {
                Toast('请选择结束时间')
                return false
            }
            let param = {
                visitor_id: this.stroeArr[this.stroeActive].visitor_id,
                mute_start_time: this.chooseTimeValue[0],
                mute_end_time: this.chooseTimeValue[1],
                mute_notification_switch: this.chooseTimeValue[0] == this.chooseTimeValue[1] ?0 :1
            }
            let data = {
                page_from:'main_page',
                page_name:'MessageSwitch',
                btn_name: 'changeTimeBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
                
            };
            this.$store.dispatch('Public/inH5Record', data)
            this.$store.dispatch('MessageSwitch/saveMuteSet',param).then(res=>{
                if(res.code == 1000) {
                    if(this.chooseTimeValue[0] !== this.chooseTimeValue[1]) {
                        this.getData()
                    }else {
                        this.stroeArr[this.chooseStroeActive].mute_start_time = this.chooseTimeValue[0]
                        this.stroeArr[this.chooseStroeActive].mute_end_time = this.chooseTimeValue[1]
                    }
                    Toast('设置成功')
                }else {
                    Toast(res.message)
                }
            })
            this.colsePopup()
        },
        stroeDetermineBtn() {
            this.choose_stroe_popup = false
            this.chooseStroeActive = this.stroeActive
        },
        noneStroe() {
            this.choose_stroe_popup = false
            this.stroeActive = this.chooseStroeActive
        },
        colsePopup(){
            this.choose_time_popup = false
            // this.chooseTimeValue = ['', '']
            this.chooseTimeActive = 0
            this.currentTime = '00:00'
        },
        chooseStroeBtn() {
            if(this.stroeArr.length>1) {
                this.choose_stroe_popup = true
            }
            let data = {
                page_from:'main_page',
                page_name:'MessageSwitch',
                btn_name: 'chooseStroeBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
                
            };
            this.$store.dispatch('Public/inH5Record', data)
        },
        changeStroe(index) {
            this.stroeActive = index
        },
    }
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>
<style lang="scss">
    // 重写 .van-popup 样式
    .van-popup{
        background-color: rgba(0,0,0,0);
    } 
    // 重写 Picker 样式
    .van-picker__toolbar{
        height: 12vw;
        border-bottom: 1px solid rgb(241, 241, 241);
    }
    .van-picker__cancel, .van-picker__confirm{
        font-size: 3.45vw;
        padding: 0 7.35vw;
    }
    .van-picker__cancel{
        color: rgb(102, 102, 102);
    }
    .van-picker__confirm{
        color: rgb(30, 100, 247);
    }
    .van-picker__title{
        font-weight: bold;
        font-size: 4vw;
    }
    .van-picker-column{
        font-size: 3.7vw;
    }
    .van-picker__frame{
        width: 100%;
        left: 0;
    }
    // 重写时间选择器样式开始
    // .chooseTimePopup .van-picker {
    //     margin-top: -2vw ;
    // }
    .chooseTimePopup .van-picker .van-picker__toolbar {
        display: none !important;
    }
    .chooseTimePopup .van-picker .van-picker__columns {
        height: 50vw !important;
        width: 70vw;
        margin: 5vw auto 0;
    }
    .chooseTimePopup .van-picker .van-hairline-unset--top-bottom {
        display: none !important;
    }
    .chooseTimePopup .van-picker .van-picker__columns .van-picker-column__wrapper .van-picker-column__item--selected {
        font-size: 4.8vw;
    }
    
    // 重写时间选择器样式结束
    [class*=van-hairline]::after{
        border: none;
        background-color: rgba(124, 124, 124, 0.1);
    }
    .title_icon .iconfont {
        font-size: 5vw;
    }
</style>